import React from 'react';
import { useTranslation } from 'react-i18next';
import IntelligenceBg from '../../assets/images/hardware-first/intelligence-bg.webp';
import IntelligenceCard from '../../assets/images/hardware-first/intelligence-card.webp';
import { ReactComponent as IconBell } from '../../assets/images/icons/icon_bell.svg';
import { ReactComponent as IconChat } from '../../assets/images/icons/chat.svg';
import { ReactComponent as IconHeart } from '../../assets/images/icons/icon_heart.svg';
import { ReactComponent as IconMagic } from '../../assets/images/icons/icon_magic.svg';
import SimpleDismissableModal from '../modals/SimpleDismissableModal';
import styles from './HardwareFirstIntelligenceModal.module.scss';

const ROWS = [
  { Icon: IconBell, titleKey: 'pdp_v2_intel_updates_title', bodyKey: 'pdp_v2_intel_updates_body' },
  { Icon: IconChat, titleKey: 'pdp_v2_intel_ask_title', bodyKey: 'pdp_v2_intel_ask_body' },
  { Icon: IconHeart, titleKey: 'pdp_v2_intel_data_title', bodyKey: 'pdp_v2_intel_data_body' },
];

/** The sheet behind the solo page's AI health insights tile: what Fi Intelligence does, in three rows. */
export default function HardwareFirstIntelligenceModal({ trigger }: { trigger: JSX.Element }) {
  const { t } = useTranslation();
  return (
    <SimpleDismissableModal trigger={trigger} containerClassName={styles.modal} closeIconClassName={styles.closeIcon}>
      {(close) => (
        <div className={styles.container}>
          <div className={styles.scroll}>
            <div className={styles.hero} style={{ backgroundImage: `url(${IntelligenceBg})` }}>
              <img className={styles.heroCard} src={IntelligenceCard} alt="" />
            </div>
            <div className={styles.body}>
              <div className={styles.eyebrow}>
                <IconMagic />
                <span>{t('pdp_v2_intel_eyebrow')}</span>
              </div>
              <h2 className={styles.title}>{t('pdp_v2_intel_title')}</h2>
              <p className={styles.sub}>{t('pdp_v2_intel_sub')}</p>
              <ul className={styles.rows}>
                {ROWS.map(({ Icon, titleKey, bodyKey }) => (
                  <li key={titleKey} className={styles.row}>
                    <span className={styles.rowIcon}>
                      <Icon />
                    </span>
                    <span>
                      <span className={styles.rowTitle}>{t(titleKey)}</span>
                      <span className={styles.rowBody}>{t(bodyKey)}</span>
                    </span>
                  </li>
                ))}
              </ul>
              <p className={styles.foot}>{t('pdp_v2_intel_foot')}</p>
            </div>
          </div>
          <div className={styles.ctaBar}>
            <button type="button" className={styles.cta} onClick={close}>
              {t('got_it')}
            </button>
          </div>
        </div>
      )}
    </SimpleDismissableModal>
  );
}
